import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import StarsRating from "stars-rating";

import { setLoading } from "../../../reducer/auth/auth";
import {
  deleteUserFeedbacks,
  getMediumProfileDetails,
} from "../../../services/admin";
import { setPathArray } from "../../../reducer/adminSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// import BookingPopUp from "./bookingpopup";
import "./view.css";
import { getMediumPublicFeedbacksList, getMediumPublicProfileDetails } from "../../../services/uidata";
import { getMediumFeedbacksList } from "../../../services/client";
import { isHTML } from "../../../utils/helpers";
const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
     <style>
        body {
          margin: 0;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
// giftMode: opened from a VerySoul Gift's medium list (/profile-view/:id?from=gift)
// — read-only, no paid booking from here.
export default function PractitionerInfo({ PractitionerInfo, onClick, view, show, giftMode = false }) {
  const { t } = useTranslation("publicMisc");
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("view");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // auth.auth is false when a valid access_token is present (see reducer/auth/auth.js),
  // so `!auth.auth` tells us the viewer is logged in. Combined with usertype === 1 (admin,
  // see utils/utils.js userType()) this gates the feedback delete button to logged-in admins.
  const auth = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.user);
  const isAdmin = !auth.auth && user && user.usertype === 1;
  const [profile, setProfile] = useState(null);
  const [queryValue, setQueryValue] = useState('');
  const params = useParams();
   const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("100px");

  // Client Reviews pagination: get-medium-details now returns just the first 2
  // feedback entries (feedbacks_has_more tells us if there's more), so we seed
  // review state from the profile once it loads. The infinite-scroll sentinel
  // then fetches 5 more at a time. For the public/guest flow (view === 'public')
  // there's no auth token, so we hit the public /get-medium-feedbacks route;
  // the authenticated admin flow keeps using the auth /user/get-medium-feedbacks.
  const LOAD_MORE_REVIEWS_LIMIT = 5;
  const [reviews, setReviews] = useState([]);
  const [reviewsOffset, setReviewsOffset] = useState(0);
  const [hasMoreReviews, setHasMoreReviews] = useState(false);
  const [loadingReviews, setLoadingReviews] = useState(false);
  const loadMoreRef = useRef(null);

  const loadMoreReviews = () => {
    const medium_id = profile && profile.general ? profile.general.medium_id : undefined;
    if (!medium_id) return;
    setLoadingReviews(true);
    const fetcher = view === "public"
      ? getMediumPublicFeedbacksList(medium_id, reviewsOffset, LOAD_MORE_REVIEWS_LIMIT)
      : getMediumFeedbacksList(medium_id, reviewsOffset, LOAD_MORE_REVIEWS_LIMIT);
    fetcher
      .then((data) => {
        if (data.data.status) {
          const { feedbacks: newFeedbacks, has_more, offset: returnedOffset, limit: returnedLimit } = data.data.data;
          setReviews((prev) => [...prev, ...newFeedbacks]);
          setReviewsOffset(returnedOffset + returnedLimit);
          setHasMoreReviews(has_more);
        }
      })
      .catch(() => { })
      .finally(() => setLoadingReviews(false));
  };

  // Infinite scroll: auto-load the next page of reviews when the sentinel at the
  // bottom of the list scrolls into view.
  useEffect(() => {
    if (!hasMoreReviews) return;
    const el = loadMoreRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingReviews) {
          loadMoreReviews();
        }
      },
      { root: null, rootMargin: "200px", threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMoreReviews, loadingReviews, reviewsOffset]);

    useEffect(() => {
      const handleMessage = (event) => {
          if (event.data && event.data.type === "setHeight") {
              let height =  event.data.height + 65;
          setIframeHeight(height + "px");
          }
      };

      window.addEventListener("message", handleMessage);
      return () => window.removeEventListener("message", handleMessage);
      }, []);

  useEffect(() => {


    dispatch(setPathArray(params.id));
    getProfile(params.id);
    setQueryValue(status)
    setTimeout(() => {
      removeQueryParams()
    }, 2000);
    return () => {
      dispatch(setPathArray(null));
    };
  }, []);
  const removeQueryParams = () => {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("view");
    // newUrl.searchParams.delete("id");
    window.history.replaceState({}, document.title, newUrl.href);

    // if (status) {
    //   // 👇️ delete each query param
    //   searchParams.delete('view');

    //   // 👇️ update state after
    //   setSearchParams(searchParams);
    // }
  };
  const getProfile = (id) => {
    dispatch(setLoading(true));
    let set = view === 'public' ? getMediumPublicProfileDetails(id) : getMediumProfileDetails(id)

    set.then((data) => {
      dispatch(setLoading(false));
      if (data.data.status) {
        const arraydata = data.data.data;
        if (
          Array.isArray(arraydata.preferences) &&
          arraydata.preferences.length === 0
        )
          arraydata.preferences = {};
        if (
          Array.isArray(arraydata.morePreferences) &&
          arraydata.morePreferences.length === 0
        )
          arraydata.morePreferences = {};
        setProfile(arraydata);
        // Seed the paginated reviews list from the initial profile payload.
        const seededFeedbacks = Array.isArray(arraydata.feedbacks) ? arraydata.feedbacks : [];
        setReviews(seededFeedbacks);
        setReviewsOffset(seededFeedbacks.length);
        setHasMoreReviews(!!arraydata.feedbacks_has_more);
      }
    })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };
  const deleteFeedBacks = (feedback_id) => {
    let body = {
      feedback_id,
    };
    deleteUserFeedbacks(body)
      .then((data) => {
        if (data.data.status) {
          toast.success(t("profileView.feedbackDeleted"), {
            position: "top-center",
          });
          getProfile(params.id);
        }
      })
      .catch(() => { });
  };
      const getBio = (info) =>{
        const rawContentFromDB = info
        let html;
      if (!isHTML(rawContentFromDB)) {
        let info =
          rawContentFromDB
            .split("\n")
            .map(line => `${line}`)
            .join("");
        console.log(info, "cejdncjkm");
        html = info
        return info
      }
      else {

        html = JSON.parse(rawContentFromDB).content
        return <div dangerouslySetInnerHTML={{ __html: JSON.parse(rawContentFromDB).content }} />
      }

  }
  const getInfo = (info) => {
    
            const rawContentFromDB = info
            let html;
            if (!isHTML(rawContentFromDB)) {
                console.log( info,"ckejdnm1")
                let info =
                    rawContentFromDB
                        .split("\n")
                        .map(line => `${line}`)
                        .join("");
                console.log(info, "cejdncjkm");
                html = info
                return info
            }
            else {
               // console.log( info,"ckejdnm2")
                // html = JSON.parse(rawContentFromDB).content
                // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />
                
                  html = JSON.parse(rawContentFromDB).content
                  const srcDoc = generateSrcDoc(html);
                return srcDoc 
            }
    
    // "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"
    
        }
    return (
    <div className="container-fluid px-2 px-md-4 py-3 schedule-advance-box-all-container">
      <div className="single-profile-saction single-profile-saction-new">

        {/* Back button */}
        {show == undefined && (
          <>
            {view !== "public" && (
              <div onClick={onClick} className="back-btn-profile">
                <div className="bac-href pointer">
                  <img
                    className="bac-img"
                    src="/images/arrow-back.png"
                    alt="back"
                    onClick={() => status === null ? navigate(-1) : navigate(`/mediums?view=${queryValue}`)}
                  />
                  {t("profileView.goBack")}
                </div>
              </div>
            )}
          </>
        )}

        <div className="profile-all-box">

          {/* Banner */}
          <div className="banner-img-profile">
            <img src="/images/profile-cover.png" alt="avatar" />
          </div>

          {/* Profile header row */}
          <div className="px-3 px-md-4 pt-3">
            <div className="row align-items-start">

              {/* Avatar */}
              <div className="col-auto">
                <div className="profile-image">
                  <img
                    className="public-profile-picture"
                    src={
                      profile !== null && profile.general.profile_image !== ""
                        ? process.env.REACT_APP_IMAGE_URL + profile.general.profile_image
                        : "/images/user-dummy.png"
                    }
                    alt="avatar"
                  />
                </div>
              </div>

              {/* Name + rating */}
              <div className="col" style={{ minWidth: 0 }}>
                <div className="profile-name">
                  <div className="nam-prof">
                    {profile !== null && profile.preferences.screen_name}
                  </div>
                  <a href="#" className="mt-1 d-block" style={{ fontSize: "14px", color: "#555" }}>
                    {profile !== null && profile.preferences.screen_name}
                  </a>
                  <div className="star-rating mt-1">
                    {profile !== null && (
                      <StarsRating
                        count={5}
                        value={profile.general.average_rating || 0}
                        size={20}
                        color2={"#ffc107"}
                        edit={false}
                        color1={"gray"}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* Book Here button */}
              {!giftMode && (
              <div className="col-12 col-sm-auto mt-2 mt-sm-0">
                <div className="profile-book-now" style={{ float: "none", width: "100%", padding: 0 }}>
                  {view !== "public" ? (
                    <a
                      className="book-now-practice d-block text-center"
                      href={
                        profile !== null && profile.general.personal_booking_link !== ""
                          ? profile.general.personal_booking_link
                          : "#"
                      }
                    >
                      {t("profileView.bookHere")}
                    </a>
                  ) : (
                    <a
                      target="_blank"
                      className="book-now-practice d-block text-center"
                      href={`${process.env.REACT_APP_BASE_URL}guest-booking/${profile !== null && profile.general.medium_id}`}
                    >
                      {t("profileView.bookHere")}
                    </a>
                  )}
                </div>
              </div>
              )}

            </div>
          </div>

          {/* Languages & Country */}
          <div className="px-3 px-md-4 mt-3">

            {/* Languages row */}
            <div className="d-flex align-items-start mb-3" style={{ gap: "9px" }}>
              <div className="icon-detls flex-shrink-0 mr-3">
                <img src="/images/chate.png" alt="" />
              </div>
              <div className="d-flex flex-wrap align-items-center" style={{ gap: "8px", paddingTop: "6px" }}>
                <em style={{ fontStyle: "normal", color: "#000", fontSize: "15px", marginRight: "4px" }}>
                  {t("profileView.languages")}
                </em>
                {profile !== null &&
                  profile.general.languages.map((data) => (
                    <span
                      key={data.lanugage_name}
                      style={{
                        display: "inline-block",
                        height: "36px",
                        lineHeight: "36px",
                        border: "1px solid #D5A67B",
                        borderRadius: "5px",
                        padding: "0 16px",
                        color: "#000",
                        fontSize: "14px",
                      }}
                    >
                      {data.lanugage_name}
                    </span>
                  ))}
              </div>
            </div>

            {/* Country row */}
            <div className="d-flex align-items-center mb-3" style={{ gap: "9px" }}>
              <div className="icon-detls flex-shrink-0 mr-3">
                <img src="/images/word.png" alt="" />
              </div>
              <em style={{ fontStyle: "normal", color: "#000", fontSize: "15px", marginRight: "8px" }}>
                {t("profileView.country")}
              </em>
              <span
                style={{
                  display: "inline-block",
                  height: "36px",
                  lineHeight: "36px",
                  border: "1px solid #D5A67B",
                  borderRadius: "5px",
                  padding: "0 16px",
                  color: "#D5A67B",
                  fontSize: "14px",
                }}
              >
                {profile !== null && profile.general.country}
              </span>
            </div>

          </div>

          {/* About Me (bio iframe) */}
          <div className="profile-bio px-3 px-md-4">
            <h3><b>{t("profileView.aboutMe")}</b></h3>
            {profile !== null && (
              <iframe
                ref={iframeRef}
                srcDoc={getInfo(profile.general.biographical_info)}
                style={{ width: "100%", height: iframeHeight, border: "unset" }}
                title={t("profileView.bioFrameTitle")}
              />
            )}
          </div>

          {/* Reviews section */}
          <div className="profile-bio px-3 px-md-4">
            <button
              type="button"
              className="btn btn-primary bg-theme-d5a67b height-35 d-block mb-5"
              data-toggle="modal"
              data-target=".bd-example-modal-lg"
            >
              {t("profileView.aboutReviews.title")}
            </button>

            {/* About Our Reviews modal */}
            <div
              className="modal fade bd-example-modal-lg mt-5"
              tabIndex="-1"
              role="dialog"
              aria-labelledby="myLargeModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-lg modal-dialog-preview">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      {t("profileView.aboutReviews.title")}
                    </h5>
                    <button
                      type="button"
                      className="close about-us-review-close"
                      data-dismiss="modal"
                      aria-label={t("profileView.close")}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body p-5">
                    <p className="review-Popup">
                      {t("profileView.aboutReviews.p1")}
                    </p>
                    <br />
                    <p className="review-Popup">
                      {t("profileView.aboutReviews.p2")}
                    </p>
                    <br />
                    <p className="review-Popup">
                      {t("profileView.aboutReviews.p3")}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h2 className="mb-3">
              {profile !== null && profile.general.recommendation !== ""
                ? t("profileView.clientReviewsRecommend", {
                    percent: profile.general.recommendation,
                  })
                : t("profileView.clientReviews")}
            </h2>

            {/* Feedback list */}
            <div className="feedback-container">
              {profile !== null &&
                reviews.map((feedback, idx) => (
                  <div key={idx} className="feedback-border-feed row border-bottom py-3 mx-0 mt-2">

                    {/* Left: avatar + name + stars + date */}
                    <div className="col-12 col-md-4 mb-2 mb-md-0">
                      <div className="d-flex align-items-center">
                        <div className="feedback-image flex-shrink-0">
                          <img
                            className="practioner-profile-image"
                            src="../images/user-dummy.png"
                            alt="avatar"
                          />
                        </div>
                        <span className="ml-2" style={{ fontSize: "14px" }}>
                          {feedback.client_name} —{" "}
                          {JSON.parse(feedback.feedback).Country}
                        </span>
                      </div>
                      <div className="feedback-star-image mt-1">
                        <StarsRating
                          count={5}
                          value={parseInt(JSON.parse(feedback.feedback).Star_Rating)}
                          size={20}
                          color2={"#ffc107"}
                          edit={false}
                          color1={"#FFFFFF"}
                        />
                      </div>
                      <p className="feedback-date mb-0">{feedback.feedback_date}</p>
                    </div>

                    {/* Middle: title + body */}
                    <div className="col-12 col-md-7">
                      <span className="feedback-heading d-block mb-1">
                        {JSON.parse(feedback.feedback).Title}
                      </span>
                      <span style={{ fontSize: "14px", color: "#555" }}>
                        {JSON.parse(feedback.feedback).Publishable_Feedback}
                      </span>
                    </div>

                    {/* Right: delete (admins only) */}
                    {isAdmin && (
                      <div className="col-12 col-md-1 d-flex align-items-start justify-content-end justify-content-md-center mt-2 mt-md-0">
                        <img
                          onClick={() => deleteFeedBacks(feedback.feedback_id)}
                          className="pointer"
                          src="../images/icon-b2.png"
                          alt="delete"
                        />
                      </div>
                    )}

                  </div>
                ))}
            </div>

            {hasMoreReviews && (
              <div ref={loadMoreRef} style={{ height: 1 }} />
            )}
            {loadingReviews && (
              <div className="text-center mt-3" style={{ fontSize: "14px", color: "#555" }}>
                {t("profileView.loading")}
              </div>
            )}
          </div>

        </div>
      </div>
      {/* <BookingPopUp item={PractitionerInfo} /> */}
    </div>
  );
}
